import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";

const initConstructionProgressSlider = () => {
  const sliderEl = document.querySelector(".construction-progress__slider");
  if (!sliderEl) return;

  const sectionEl = sliderEl.closest(".construction-progress");
  const navEl = sectionEl?.querySelector(".construction-progress__nav");
  const prevEl = sectionEl?.querySelector(".construction-progress__btn--prev");
  const nextEl = sectionEl?.querySelector(".construction-progress__btn--next");
  const scrollbarEl = sectionEl?.querySelector(".construction-progress__scrollbar");
  const isRelatedVariant = sectionEl?.classList.contains("construction-progress--related");
  const updateNavigationVisibility = (swiper) => {
    if (navEl) navEl.hidden = swiper.isLocked;
  };

  const slider = new Swiper(sliderEl, {
    modules: [Keyboard, Mousewheel, Navigation, Scrollbar],
    slidesPerView: isRelatedVariant ? 1 : 1.4,
    spaceBetween: 10,
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    scrollbar: {
      el: scrollbarEl,
      draggable: false,
    },
    on: {
      init: updateNavigationVisibility,
      lock: updateNavigationVisibility,
      unlock: updateNavigationVisibility,
      breakpoint: updateNavigationVisibility,
      resize: updateNavigationVisibility,
    },
    breakpoints: {
      768: {
        slidesPerView: isRelatedVariant ? 1 : 2,
        spaceBetween: 10,
      },
      993: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });

  updateNavigationVisibility(slider);
};

export default initConstructionProgressSlider;
